import { render, staticRenderFns } from "./v-sidebar.vue?vue&type=template&id=437fd2d7&scoped=true&"
import script from "./v-sidebar.vue?vue&type=script&lang=js&"
export * from "./v-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./v-sidebar.vue?vue&type=style&index=0&id=437fd2d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437fd2d7",
  null
  
)

export default component.exports